import Cookies from 'js-cookie';
import { useCookies } from 'react-cookie';

const nextMonth = new Date();
nextMonth.setDate(new Date().getDate() + 31);

export const useLocalStorage = () => {
  const [cookies, setCookie, removeCookie] = useCookies([
    'FitogramAccessToken',
    'FitogramRefreshToken',
    'FitogramTokenExpiration',
    'FitogramProviderUUId',
    'FitogramRedirectURL',
    'FitogramProviderUUIdAfterARedirectIsCleaned',
  ]);

  const logout = () => {
    removeCookie('FitogramAccessToken', { path: '/' });
    removeCookie('FitogramRefreshToken', { path: '/' });
    removeCookie('FitogramTokenExpiration', { path: '/' });
    const redirectUrl = localStorage.getItem('FitogramRedirectURL') as string;
    localStorage.clear();
    localStorage.setItem('FitogramRedirectURL', redirectUrl);
  };

  return {
    accessToken: localStorage.getItem('FitogramAccessToken') as string,
    refreshToken: cookies.FitogramRefreshToken as string,
    expirationToken: parseInt(cookies.FitogramTokenExpiration || '0', 10),
    providerUUId: localStorage.getItem('FitogramProviderUUId') as string,
    redirectUrl: localStorage.getItem('FitogramRedirectURL') as string,
    providerUUIdAfterARedirectIsCleaned:
      (localStorage.getItem('FitogramProviderUUIdAfterARedirectIsCleaned') as string) === 'true',
    setAccessToken: (accessToken: string) =>
      localStorage.setItem('FitogramAccessToken', accessToken),
    setRefreshToken: (refreshToken: string) =>
      setCookie('FitogramRefreshToken', refreshToken, { path: '/', expires: nextMonth }),
    setExpirationToken: (expirationToken: number) =>
      setCookie('FitogramTokenExpiration', expirationToken.toString(), {
        path: '/',
        expires: nextMonth,
      }),
    setProviderUUId: (providerUUId: string) =>
      localStorage.setItem('FitogramProviderUUId', providerUUId),
    setRedirectUrl: (url: string) => localStorage.setItem('FitogramRedirectURL', url),
    setProviderUUIdAfterARedirectIsCleaned: () =>
      localStorage.setItem('FitogramProviderUUIdAfterARedirectIsCleaned', 'true'),
    deleteProviderUUId: () => localStorage.removeItem('FitogramProviderUUId'),
    deleteProviderUUIdAfterARedirectIsCleaned: () =>
      localStorage.removeItem('FitogramProviderUUIdAfterARedirectIsCleaned'),
    logout,
  };
};

// getting cookies and local storage
export const getLocalStorageAccessToken = () => localStorage.getItem('FitogramAccessToken');
export const getLocalStorageProviderUUId = () => localStorage.getItem('FitogramProviderUUId');
export const getLocalStorageRefreshToken = () => Cookies.get('FitogramRefreshToken');
export const getLocalStorageExpirationToken = () =>
  parseInt(Cookies.get('FitogramTokenExpiration') || '0', 10);

// setting cookies and local storage
export const setLocalStorageAccessToken = (accessToken: string | undefined) =>
  accessToken && localStorage.setItem('FitogramAccessToken', accessToken);
export const setLocalStorageRefreshToken = (refreshToken: string | undefined) =>
  refreshToken &&
  Cookies.set('FitogramRefreshToken', refreshToken, { path: '/', expires: nextMonth });
export const setLocalStorageExpirationToken = (expirationToken: number | undefined) =>
  expirationToken &&
  Cookies.set('FitogramTokenExpiration', expirationToken.toString(), {
    path: '/',
    expires: nextMonth,
  });
export const setLocalStorageProviderUUId = (providerUUId: string | undefined) =>
  providerUUId && localStorage.setItem('FitogramProviderUUId', providerUUId);
export const deleteRedirectURL = () => localStorage.removeItem('FitogramRedirectURL');

export const logout = () => {
  Cookies.remove('FitogramAccessToken');
  Cookies.remove('FitogramRefreshToken');
  Cookies.remove('FitogramTokenExpiration');
  Cookies.remove('FitogramProviderUUId');
  localStorage.clear();
  window.location.reload();
};
